export default __webpack_public_path__ + "static/media/chatbot.3ce1d70d.png";